import { Dispatch } from "react";
import ConversationRecord from "models/view-models/conversations/conversation-record";
import ConversationService from "utilities/services/conversations/conversation-service";
import { ConversationHistoryAction } from "./conversation-history-atom-reducer";

/**
 * Renames a conversation.
 * This thunk will update the title of an existing conversation and update the state accordingly.
 */
export const pinOrUnpinConversation =
    (conversation: Pick<ConversationRecord, "id" | "isPinned">) =>
    async (dispatch: Dispatch<ConversationHistoryAction>) => {
        const pinnedStateOrDefault = conversation.isPinned ?? false;
        if (!conversation.id) {
            dispatch({
                type: "ERROR",
                error: new Error("Conversation ID is required"),
            });
            return;
        }

        // Immediately dispatch the pin/unpin action to update the UI optimistically
        dispatch({
            type: "PIN_OR_UNPIN_CONVERSATION",
            id: conversation.id,
            isPinned: pinnedStateOrDefault,
        });

        const errorMessage =
            "Something went wrong, your changes were not saved.";

        try {
            await ConversationService.pin(
                { id: conversation.id },
                { isPinned: pinnedStateOrDefault }
            );
            return;
        } catch (error) {
            dispatch({
                type: "ERROR",
                error: new Error(errorMessage),
            });
        }

        dispatch({
            type: "ERROR",
            error: new Error(errorMessage),
        });
    };
